export const environment = {
    production: true,
    basePathApi: 'https://wondrlink-back.vercel.app/api',
    authPathApi: 'https://wondrlink-back.vercel.app/api/auth',
    geoPathAPI: 'https://api.geoapify.com/v1/geocode/autocomplete',
    geoApiKey: '3b23dc57405b446fbbf29846a2d2b6dd',
    locationIqToken: 'pk.0e75ab005ceb08e738472e1ae6f534ca',
    geniusscansdkToken: '533c50075255000201550e59395d5a00050f5a0b47426d0855000756050c01055b'
};
